//
// Spin Controller
//
// ----------------------------
spinController = {};
spinController.mainSpinConfig = {};
spinController.mainLandConfig = {};
spinController.montezumaActiveReels = [false, false, false, false, false];
spinController.longSpinMontezuma = false;
spinController.landSymbols = [];
spinController.reelCount = gameData.NUM_REELS;
spinController.totalSpinTime = 2.0;
spinController.bonusReelBand = [
  1, 9, 9, 9, 9, 1, 4, 4, 14, 4, 0, 4, 4, 7, 4, 10, 8, 2, 2, 8, 1, 14, 4, 4, 1, 3, 10, 8, 8, 6, 4, 4, 6, 8, 8, 4, 6, 7,
  8, 8, 8, 6, 14, 1, 8, 10, 6, 10, 8, 8, 8, 1, 14, 2, 7, 0, 10, 0, 8, 2, 9, 9, 9, 9, 1, 3, 5, 5, 5, 5, 5, 3, 14, 3, 8,
  3, 5, 5, 5, 14, 0, 0, 3, 3, 1, 5, 3, 3, 5, 5, 5, 3, 2, 5, 0, 0, 3, 3, 1, 6, 0, 0, 0, 0, 6, 6, 1, 6, 9, 9, 9, 9, 4, 4,
  2, 2, 0, 14, 0, 4, 5, 3, 2, 7, 7, 2, 2, 7, 7, 7, 1, 7, 6, 1, 7, 3, 2, 3, 14, 2, 7, 7, 7, 9, 9, 9, 9, 6, 1, 0,
];

spinController.startSpin = function () {
  if (gameController.minimumGameTime > spinController.totalSpinTime) {
    spinController.totalSpinTime = gameController.minimumGameTime;
  }


  spinController.longSpinMontezuma = false;
  spinController.mainSpinConfig = {};
  spinController.mainLandConfig = {};

  const startOffsetTime = 0.3;
  const pullbackTime = 0.1;
  const accelTime = 0.2;
  const mainSpinOffset = 0.5;
  const decelTime = 0.5;
  const bounceTime = 0.1;
  const combinedTime = startOffsetTime + pullbackTime + accelTime + mainSpinOffset + decelTime + bounceTime;
  let mainSpinTime = spinController.totalSpinTime - combinedTime;

  if (mainSpinTime < 0.1) {
    mainSpinTime = 0.1;
  }

  for (let i = 0; i < spinController.reelCount; i++) {
    let mainReelStartOffset = (startOffsetTime / spinController.reelCount) * i;
    let mainReelSpinOffset = (mainSpinOffset / spinController.reelCount) * i;

    let mainReel = {
      type: 'main',
      startDelay: 0.0,
      reelStartDelayOffset: mainReelStartOffset,
      pullbackAmount: 0.2,
      pullbackTime: pullbackTime,
      pullbackStrength: 1.0,
      accelerationTime: accelTime,
      accelerationStrength: 2.0,
      symbolsPerSecond: 20,
      mainReelSpinTime: mainSpinTime,
      mainReelSpinTimeReelOffset: mainReelSpinOffset,
      decelerationTime: decelTime,
      decelerationStrength: 1.25,
      bounceAmount: 25,
      bounceTime: bounceTime,
    };
    spinController.mainSpinConfig[`reel${i}`] = mainReel;
  }

  for (let i = 0; i < spinController.montezumaActiveReels.length; i++) {
    if (spinController.montezumaActiveReels[i]) {
      spinController.montezumaActiveReels[i] = false;
      gameController.slotMachine.setMinSymbolSpacingScale(i, 1.0, 0);
      gameController.slotMachine.clearTempReelBand(i);

      let reel = resourceManager.get('mainReelsContainer:slotContainer:reelContainer:reel' + i);
      for (var j = 0; j < 4; ++j) {
        reel.setReelSymbol(j, 16);
      }
    }
  }

  gameController.slotMachine.dynamicSpin(spinController.mainSpinConfig);
};

spinController.stopSpin = function (symbols, above, below, mainSpinCompleteCallback) {
  spinController.longSpinMainReels = [false, false, false, false, false];

  spinController.landSymbols = symbols;
  spinController.checkForLongSpinReels();
  spinController.setupLandConfigs();

  gameController.slotMachine.stopReels(symbols, above, below, mainSpinCompleteCallback, spinController.mainLandConfig);
};

spinController.setupLandConfigs = function () {
  let reelsToDo = spinController.reelCount - gameController.longSpinReel;
  let totalAnticipationTime = 2;
  if (reelsToDo === 1) {
    totalAnticipationTime = 2;
  } else if (reelsToDo === 2) {
    totalAnticipationTime = 4;
  } else if (reelsToDo === 3) {
    totalAnticipationTime = 6;
  } else {
    totalAnticipationTime = 8;
  }

  let anticipationsSoFar = 0;
  let timePerReel = totalAnticipationTime / reelsToDo;
  let maxDeceleration = 10;

  for (let i = 0; i < spinController.reelCount; i++) {
    let mainReel = {};

    if (i >= gameController.longSpinReel) {
      anticipationsSoFar++;
      let totalReelTime = timePerReel * anticipationsSoFar;
      let mainSpinTime = 1;
      //let decelTime = totalReelTime;
      //if (decelTime > maxDeceleration) {
      //  decelTime = maxDeceleration;
      //  mainSpinTime = totalReelTime - decelTime;
      //}
      let decelTime = 2;
      mainSpinTime = totalReelTime - decelTime;
      if (mainSpinTime < 0) {
        mainSpinTime = 0;
      }

      mainReel = {
        type: 'main',
        mainReelSpinExtension: mainSpinTime,
        decelerationTime: decelTime,
        decelerationStrength: 2.0,
        bounceAmount: 5,
        bounceTime: 0.2,
      };

      if (i === 5 && spinController.longSpinMontezuma) {
        mainReel.decelerationTime += 2;
      }
    }

    spinController.mainLandConfig[`reel${i}`] = mainReel;
  }
};

spinController.checkForLongSpinReels = function () {
  if (gameController.inFreeSpins) {
    return;
  }

  let bonusCount = 0;

  for (let i = 0; i < spinController.reelCount; i++) {
    if (gameController.getSymbolsOnReel(i, 14).length > 0) {
      bonusCount++;

      if (bonusCount >= 2) {
        gameController.longSpinReel = i + 1;
        break;
      }
    }
  }
  if (gameController.longSpinReel > 4) {
    gameController.longSpinReel = 5;
  }
};

StateMachine.Create(spinController);

spinController.update = function (delta, time) {
  spinController.stateMachine.update();
};

spinController.stateMachine.addState('IDLE', function () {});

Reflex.addToUpdate(spinController.update);
